import React, { useContext } from 'react';

import { Loader } from '@ets-global/b2c-website-ui';

import PrepTool from '../../components/PrepTool';
import { useBasketCookie, useQuery, useRouter } from '../../hooks';
import PrepToolsLayout from '../../components/Layout/BuyingProcess/PrepTools';
import NotFoundHandler from '../../components/NotFoundHandler';
import { PREPTOOLS_VERSION } from '../../graphql/queries';
import PrepToolsInCart from '../../containers/PrepToolsInCart';
import HeaderMeta from '../../components/HeaderMeta';
import { PurchaseContext } from '../../store/Purchase';

import './styles.scss';

const PrepToolPage = () => {
  const { purchase, registrationId, refetch: purchaseRefetch } = useContext(PurchaseContext);
  const {
    currentRoute: {
      params: { slug, locale, country },
    },
  } = useRouter();
  const { getPromoCodeOrVoucher } = useBasketCookie();
  const promoCodeOrVoucher = getPromoCodeOrVoucher();

  const {
    data: { preparationTool: prepTool },
    loading,
  } = useQuery(PREPTOOLS_VERSION, {
    variables: {
      slug,
      country,
      lang: locale,
      discount:
        promoCodeOrVoucher?.discountCode && !promoCodeOrVoucher?.isVoucher
          ? { discountCode: promoCodeOrVoucher.discountCode, referrer: promoCodeOrVoucher.referrer }
          : null,
    },
  });

  if (loading) {
    return <Loader />;
  }

  if (!loading && !prepTool) {
    return <NotFoundHandler />;
  }

  let purchaseLine = null;
  let nbItemInBasket = 0;
  let purchaseLinesId = null;

  if (purchase) {
    let purchaseLines = purchase.purchaseLines.filter(
      (purchaseLine) =>
        purchaseLine.articleStock && parseInt(prepTool.articleStockId) === parseInt(purchaseLine.articleStock.id),
    );
    if (purchaseLines.length > 0) {
      purchaseLine = purchaseLines[0];
      nbItemInBasket = parseInt(purchaseLine.quantity);
      purchaseLinesId = parseInt(purchaseLine.id);
    }
  }

  return (
    <PrepToolsLayout>
      <HeaderMeta meta={prepTool.meta} page={'preparation-tool'} />
      <div className={'prep-tool-detail container container--full container--blue'}>
        <div className={'container container--padding prep-tool-detail__content'}>
          <PrepToolsInCart registrationId={registrationId} purchaseRefetch={purchaseRefetch}>
            {({ handleSubmit, isPrepToolInVoucher }) => (
              <PrepTool
                purchaseLine={purchaseLine}
                item={prepTool}
                className={'product--inline product--with-detail'}
                withDetail={true}
                onSubmit={handleSubmit(nbItemInBasket, purchaseLinesId)}
                isEditable={!purchase || (purchase && (!purchase.voucher || !purchase.voucher.isCpf))}
                isInVoucher={purchaseLine ? isPrepToolInVoucher(purchaseLine) : false}
              />
            )}
          </PrepToolsInCart>
        </div>
      </div>
    </PrepToolsLayout>
  );
};

export default PrepToolPage;
